import nGramsCommons from './commons/ngrams.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'ngrams_cissors_3',
    dependencies: [
        'levels/ngrams_cissors_2'
    ]
})

const {
    createQuestion,
    cutAndMysteryGram,
    cutAndMysteryLetter,
    realWords
} = nGramsCommons






level.addQuestion({
    generator: function (q) {
        let word = realWords()

        createQuestion(q, cutAndMysteryGram, {word, n: 3})
    }
})


level.addQuestion({
    generator: function (q) {
        let word = realWords()

        createQuestion(q, cutAndMysteryLetter, {word, n: 3})
    }
})




export default level

